import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: '48px',
        },
        indicator: {
          backgroundColor: '#000',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          color: '#000',
          '&.Mui-selected': {
            color: '#1976d2',
          },
        },
      },
    }
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
  }  
});

export default theme;
